import { z } from "zod";

export const loginSchema = z.object({
    email: z.string().min(1, "Email is required").email("Please enter a valid email address"),
    rememberMe: z.boolean(),
    password: z.string().min(1, "Password is required").min(6, "Password must be at least 6 characters long"),
});

export const defaultValues = {
    email: "",
    password: "",
    rememberMe: false,
};

export type LoginType = z.infer<typeof loginSchema>;
